import {AppForm} from "../../../../../../../common/forms/app.form";
import {Injectable} from "@angular/core";
import {FormControl, Validators} from "@angular/forms";
import {ApplicationAppEntityApplicationRead, ApplicationAppEntityApplicationWrite} from "../../../../../../../openapi";

@Injectable()
export class ContractDataUpdateOtherDataForm extends AppForm {
  constructor() {
    super({
      changeOtherData: new FormControl(false, {nonNullable: true, validators: [Validators.required]}),
      changeOtherDataDescription: new FormControl({value: '', disabled: true}, {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(5000)]
      })
    });
  }

  private get changeOtherDataDescription(): FormControl {
    return this.get('changeOtherDataDescription') as FormControl;
  }

  public changeOtherDataChange(v: boolean): void {
    if (!v) {
      this.changeOtherDataDescription?.reset();
      this.changeOtherDataDescription?.disable();
    } else {
      this.changeOtherDataDescription?.enable();
    }
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    return {
      ...this.value,
      changeOtherDataDescription: this.value.changeOtherDataDescription || null
    };
  }

  public override patchFormValues(value: ApplicationAppEntityApplicationRead): void {
    this.changeOtherDataChange(!!value?.changeOtherData);
    super.patchFormValues(value);
  }
}
